import { ITrainWidgetNotificationRequestParams } from '@/models/Train/interfaces/ITrainWidgetNotificationRequestParams';
import TrainWidgetNotificationJSC from '@/schema/TrainWidgetNotificationJSC';

import { TReqConfigValidated } from '../../services/JSCService';
import { SunnyRequestBuilder } from '../Common/SunnyRequestBuilder';

export default class TrainRequestBuilder extends SunnyRequestBuilder {
  getAPIPath(path: string): URI {
    const href = this.baseURI.clone();

    return href.equals('') || this.isProxy ? href.path(`/api/v1${path}`) : href.path(`/v6-6${path}`);
  }

  createGetWidgetNotification(reqParams: ITrainWidgetNotificationRequestParams): TReqConfigValidated {
    return this.validate(TrainWidgetNotificationJSC, reqParams).map((params) =>
      this.makeConfig('GET', '/widget/notification', params),
    );
  }
}
